import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LoadingAnimationComponent } from '../components/loading-animation/loading-animation.component';
import { LoadingLayer } from './models/loading-layer.model';

@Injectable({
  providedIn: 'root',
})
export class LoadingGraphic {
  private _overlay: OverlayRef;
  private _compRef: ComponentRef<LoadingAnimationComponent>;
  private layers: LoadingLayer[] = [];

  constructor(private overlay: Overlay, router: Router) {
    router.events.subscribe((eventData) => {
      if (eventData instanceof NavigationEnd && eventData.id !== 1) {
        this.hide(true);
      }
    });
  }

  public show(text: string, verifier: () => boolean) {
    this.layers.push(new LoadingLayer(text, verifier));

    this.layers = this.layers.filter((layer) => layer.verifier());

    this.updateText();
  }

  public hide(all: boolean = false) {
    if (all === true) {
      this.layers.splice(0);
    } else {
      this.layers = this.layers.filter((layer) => layer.verifier());
    }

    this.updateText();
  }

  private updateText(): void {
    if (this.layers.length === 0) {
      this._overlay?.detach();
      this._compRef?.destroy();
      this._overlay?.dispose();
      this._overlay = undefined;
      this._compRef = undefined;

      return;
    } else if (!this._overlay) {
      setTimeout(() => {
        if (this.layers.length > 0) {
          if (!this._overlay) {
            this._overlay = this.createOverlay();
            this._compRef = this._overlay.attach(
              new ComponentPortal(LoadingAnimationComponent)
            );
          }

          this._compRef.instance.text =
            this.layers[this.layers.length - 1]?.text;
        }
      });
    } else {
      this._compRef.instance.text = this.layers[this.layers.length - 1].text;
    }
  }

  private createOverlay(): OverlayRef {
    const config = new OverlayConfig({
      hasBackdrop: true,
      backdropClass: ['loading-graphic-backdrop', 'cdk-overlay-dark-backdrop'],
      panelClass: 'loading-graphic-panel',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      disposeOnNavigation: true,
    });

    return this.overlay.create(config);
  }
}
